<template>
  <div class="About">
   <myHead
      :title="title"
      :subtitle="subtitle"
      v-on:goBack="handleBack"
      @getFooter="getFooter"
      :getMatchHeaderId="this.getMatchHeaderId"
      :back="true"
    />
    <div class="listBox">
      <div class="searchBox">
        <div>{{tableTitle}}</div>
        <div class="search">
          <input type="text" v-model.trim="keyword" placeholder="輸入關鍵字搜索" />
          <div class="iconBox" @click="handleSearch">
            <van-icon name="search" size="16px" color="#008644" />
          </div>
        </div>
      </div>
      <div class="table" v-if="tableHead[0]">
        <div class="fixed-arrow">
          <div class="arrow-left"><span></span></div>
          <div class="arrow-right"><span></span></div>
        </div>
        <el-table :data="fields" stripe style="width: 100%" empty-text="暫無數據">
          <el-table-column  v-for="(item,index) in tableHead" :key="index" :label="item" width="120">
            <template  slot-scope="scope" >
              <div>{{scope.row[index]}}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="tableLabel">
          <div class="tableHead">
            <div>{{tableHead[0]}}</div>
          </div>
          <div>
            <div v-for="(item,index) in fields" :key="index" class="tableData">
              <div>{{item[0]}}</div>
            </div>
          </div>
        </div>
        <div class="scrollView">
          <div class="scrollBox flexBox" :style="{'width':tableWidth}">
            <div :class="index>0?'tableCol':''" v-for="(item,index) in tableHead" :key="index">
              <div v-if="index>0" class="tableHead">
                <div>{{item}}</div>
              </div>
              <div v-if="index>0">
                <div v-for="(jtem,jndex) in fields" :key="jndex" class="tableData">
                  <div>{{jtem[index]}}</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="pageBox" v-if="total">
        <div class="leftBox iconBox" @click="prevPage">
          <van-icon name="arrow-left" size="16px" />
        </div>
        <div class="page">{{pageNo}}/{{pageCount}}</div>
        <div class="leftBox iconBox" @click="nextPage">
          <van-icon name="arrow" size="16px" />
        </div>
      </div>
    </div>
    <div class="tipsBox" v-html="tableRemark">
    </div>
    <div id="footer" v-if="footer">
      <span>{{footer}}</span>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { GetMatchItemRoster, GetMatchItemResult, GetmatchTables, GetMatchItemTable } from "@/request/api";
import myHead from "@/components/myHead.vue";
import { Icon, Toast } from "vant";

import Vue from "vue";

export default {
  name: "About",
  data() {
    return {
      title: "",
      subtitle: "",
      fields: [], //表格数据信息
      tableHead: [],
      currentPage: 1,
      pageNo: 1,
      pageCount: "",
      pageSize: 20,
      total: "",
      tableTitle: "",
      tableRemark: "",
      keyword: "",
      footer: "",
      getMatchHeaderId: localStorage.getItem("getMatchHeaderId")
    };
  },
  components: {
    [Icon.name]: Icon,
    myHead
  },
  computed: {
    width: function() {
      return document.body.clientWidth;
    },
    tableWidth: function() {
      return document.body.clientWidth > 767
        ? "100%"
        : (this.tableHead.length - 1) * 120 + "px";
    }
  },
  mounted() {
    this.title = this.$route.query.title;
    this.subtitle = this.$route.query.subtitle;
    this.GetMatch();
  },
  methods: {
    handleBack: function() {
      console.log("返回");
      this.$router.go(-1);
    },
    hanhdleClick: e => {
      console.log(e);
    },
    handleSearch: function() {
      this.GetMatch();
    },
    GetMatch: function() {
      const { pageNo, pageSize, keyword } = this;
      var _this = this;
      if (this.$route.query.type == 3 || this.$route.query.type == 4) {
        GetMatchItemTable(this.$route.query.id, {
          pageNo,
          pageSize,
          keyword
        }).then(res => {
          if (res.success) {
            _this.handleData(res);
          } else {
            Toast({
              message: res.result,
              duration: 1500,
              forbidClick: true
            });
          }
        });
      }

      if (this.$route.query.type == 1) {
        GetMatchItemResult(this.$route.query.id, {
          pageNo,
          pageSize,
          keyword
        }).then(res => {
          if (res.success) {
            
            _this.handleData(res);
          } else {
            Toast({
              message: res.result,
              duration: 1500,
              forbidClick: true
            });
          }
        });
      } else if (this.$route.query.type == 0){
        GetMatchItemRoster(this.$route.query.id, {
          pageNo,
          pageSize,
          keyword
        }).then(res => {
          if (res.success) {
            
            _this.handleData(res);
          } else {
            Toast({
              message: res.result,
              duration: 1500,
              forbidClick: true
            });
          }
        });
      }
    },
    handleData: function(res) {
      let _this = this;
      if (res.data.records.length > 0) {
        let formData = res.data.records; //获取表头列表
        this.tableTitle = formData[0].title;
        this.tableRemark = formData[0].remark;
        this.pageCount = res.data.pages;
        this.total = res.data.total;
        let fields = res.data.records[0].fields; //将表头信息赋值
        let typeName = fields.split(","); //字符分割表头信息，得到数组
        _this.tableHead = typeName;
        //_this.fields.push(typeName);

        _this.fields = [];
        //将每条记录的fieldValues具体信息存入tableData中
        for (let i = 0; i < formData.length; i++) {
          //分割fieldValues字段
          let fieldValuesArr = formData[i].fieldValues.split(",");
          //将具体数据推入fields中
          _this.fields.push(fieldValuesArr);
        }
      } else {
        _this.fields = [];
        _this.tableHead = [];
        this.pageCount = "";
        this.total = "";
      }
    },
    prevPage: function() {
      let { pageNo, pageCount } = this;
      if (pageNo == 1) {
        this.$toast("已经是首页啦");
      } else {
        this.pageNo = --pageNo;
        console.log(this.pageNo);

        this.GetMatch();
      }
    },
    getFooter: function(val) {
      this.footer = val;
    },

    nextPage: function() {
      let { pageNo, pageCount } = this;
      if (pageNo == pageCount) {
        this.$toast("已经是尾页啦");
      } else {
        this.pageNo = ++pageNo;
        console.log(this.pageNo);

        this.GetMatch();
      }
    }
  }
};
</script>

<style lang="less">
.About{
 .table {
   position: relative;
 }
  .fixed-arrow {
    width: 30px;
    height: 80px;
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;

    .arrow-left,
    .arrow-right {
      width: 30px;
      height: 23px;
      background: #000;
      opacity: .8;
      text-indent: 11px;
    }
    .arrow-right {
      opacity: .6;
    }
    .arrow-left span {
      display: inline-block;
      width:0;
      height:0;
      border-top:7px solid transparent;
      border-bottom:7px solid transparent;
      border-left:10px solid #fff;
      margin-top: 5px;
    }
    .arrow-right span {
      display: inline-block;
      width:0;
      height:0;
      border-top:7px solid transparent;
      border-bottom:7px solid transparent;
      border-right:10px solid #fff;
      margin-top: 5px;
    }
  }
  .el-table__fixed-header-wrapper, .el-table__header-wrapper {
    background: #403f41 !important;
    color: white !important;
    & th {
      background: #403f41 !important;
      color: white !important;
    }
  }
  .el-table__fixed-body-wrapper, .el-table__body-wrapper{
    .el-table__row:nth-child(even){
      background: #e0e1e1;
    }
     .el-table__row:nth-child(odd){
      background: #ebebec;
    }
  }
  }
</style>
<style scoped lang="less">
.searchBox {
  padding: 10px 20px;
  background: #008644;
  display: flex;
  // flex: 2;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: white;
  .search {
    display: flex;
    background: white;
    border-radius: 20px;
    padding-left: 15px;
    padding-right: 5px;
    & > input {
      max-width: 100px;
      flex: 1;
      outline: none;
      border: 0;
      color: black;
    }
  }
}

.table {
  display: flex;
  font-size: 14px;
  .scrollView {
    width: 100%;
    overflow-x: auto;
  }
  .tableLabel {
    width: 140px;
  }
  .tableLabel,
  .tableCol {
    display: flex;
    flex-direction: column;
    .tableData:nth-child(even) {
      background: #ebebec;
    }
    .tableData:nth-child(odd) {
      background: #e0e1e1;
    }
  }
  .flexBox {
    display: flex;
  }
  .tableHead {
    background: #403f41;
    color: white;
  }
  .tableHead,
  .tableData {
    line-height: 25px;
    padding: 5px 10px;
  }
}
.pageBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 44px;
}
.iconBox {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tipsBox {
  color: #6c6e70;
  font-size: 12px;
  padding: 0 20px;
}
@media screen and (min-width: 768px) {
  .table {
    .tableHead,
    .tableData {
      flex: 1;
    }
    .tableCol {
      flex: 1;
    }
  }
}
@media screen and (max-width: 767px) {
  .table {
    .tableHead,
    .tableData {
      min-width: 120px;
      box-sizing: border-box;
    }
  }
}
@media screen and (min-width: 415px) {
  .fixed-arrow {
    display: none;
  }
}



</style>
